import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-colors duration-300 ease-out rounded-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#C26D5C] focus:ring-offset-[#FAF7F2]';
  const variants = {
    primary: 'bg-[#C26D5C] text-[#FAF7F2] hover:bg-[#A85A4A]',
    secondary: 'bg-[#1C1917] text-[#FAF7F2] hover:bg-[#332E2B]',
    outline: 'border border-[#1C1917] text-[#1C1917] hover:bg-[#1C1917] hover:text-[#FAF7F2]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  const content = <motion.div whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className="w-full h-full flex items-center justify-center" data-id="element-153">
      {children}
    </motion.div>;
  if (href) {
    return <a href={href} className={classes} data-id="element-154">
        {content}
      </a>;
  }
  return <button className={classes} {...props} data-id="element-155">
      {content}
    </button>;
}